import { USER_ROLES } from '@app/constants/user';

export const getAccessLevelOptions = t => [
  {
    id: USER_ROLES.HR_ADMIN,
    display: t(`accessLevels.hrAdmin`),
  },
  {
    id: USER_ROLES.SYSTEM_ADMIN,
    display: t(`accessLevels.systemAdmin`),
  },
  {
    id: USER_ROLES.EMPLOYEE,
    display: t(`accessLevels.employee`),
  },
  {
    id: USER_ROLES.DEPENDENT,
    display: t(`accessLevels.dependent`),
  },
];
